export const STATUS_META = {
    draft: { label: "Szkic", cls: "bg-gray-100 text-gray-700" },
    scheduled: { label: "Zaplanowano", cls: "bg-indigo-100 text-indigo-800" },
    sending: { label: "Wysyłanie…", cls: "bg-blue-100 text-blue-800 animate-pulse" },
    sent: { label: "Wysłano", cls: "bg-emerald-100 text-emerald-800" },
    partial: { label: "Częściowo", cls: "bg-amber-100 text-amber-800" },
    failed: { label: "Błąd", cls: "bg-red-100 text-red-700" },
};

export const StatusBadge = ({ status, testid }) => {
    const m = STATUS_META[status] || STATUS_META.draft;
    return <span data-testid={testid} className={`inline-flex px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider font-semibold ${m.cls}`}>{m.label}</span>;
};

export const ProgressBar = ({ sent = 0, failed = 0, total = 0 }) => {
    if (!total) return null;
    const pct = (n) => `${Math.min(100, (n / total) * 100)}%`;
    return (
        <div className="h-1.5 w-full rounded-full bg-gray-100 overflow-hidden flex">
            <div className="bg-emerald-500 transition-[width] duration-500" style={{ width: pct(sent) }} />
            <div className="bg-red-400 transition-[width] duration-500" style={{ width: pct(failed) }} />
        </div>
    );
};
